<template>
  <v-btn
    :disabled="disabled"
    :loading="loading"
    :color="color"
    :dark="!disabled"
    small
    @click="$emit('click')"
    class="mr-2"
    text
  >
    <v-icon left :color="color">{{ icon }}</v-icon>
    {{ title }}
  </v-btn>
</template>

<script>
export default {
  props: {
    disabled: Boolean,
    loading: Boolean,
    icon: String,
    color: String,
    title: String
  }
}
</script>
